import { invoiceRequest } from '@services'
import { isEmail, onCount } from '@/utils/basicUtil'
import { deepCopy } from '@utils/basicUtil'
import moment from 'moment'
import { Notify } from 'vant'
export default {
  namespaced: true,
  state: {
    query: {
      current: 1,
      size: 25,
      startDate: new Date(moment().startOf('month').format('YYYY/M/D')),
      endDate: new Date(moment().endOf('month').format('YYYY/M/D')),
      purchaserName: '',
      invoiceType: ''
    },
    total: 0,
    invoiceInfo: {},
    tableData: [],
    loading: false
  },
  actions: {
    async getInvoiceInfoById ({ commit }, id) {
      const res = await invoiceRequest.apply.getInvoiceInfo({ id })
      if (res.success) {
        res.result.sellerInvoiceDetails.forEach(item => {
          if (item.quantity) {
            item.price = Number(onCount.div(item.amountWithTax || 0, item.quantity)).toFixed(8)
          }
        })
        await commit('setInvoiceInfo', { ...res.result,
          flag: 0,
          drewDate: res.result.drewDate ? res.result.drewDate.split(' ')[0] : '',
          details: res.result.sellerInvoiceDetails || []
        })
      } else {
        Notify({ type: 'danger', message: res.message })
      }
    },
    async sendEmailAndPhone ({ commit }, sendInfo) {
      // 如果手机号存在
      if (!sendInfo.purchaserPhone && !sendInfo.mailAddress) {
        Notify({ type: 'danger', message: '手机号/邮箱，必填一个' })
        return true
      }
      if (sendInfo.purchaserPhone && sendInfo.purchaserPhone.trim()) {
        const re = /^1[3,4,5,6,7,8,9][0-9]{9}$/
        const result = re.test(sendInfo.purchaserPhone)
        if (!result) {
          Notify({ type: 'danger', message: '手机号格式不正确' })
          return true
        }
      }
      // 如果邮箱存在
      if (sendInfo.mailAddress && sendInfo.mailAddress.trim()) {
        if (!isEmail(sendInfo.mailAddress)) {
          Notify({ type: 'danger', message: '邮箱格式不正确' })
          return true
        }
      }
      const sendRes = await invoiceRequest.apply.sendEmail(sendInfo)
      await invoiceRequest.apply.createEmail({ email: sendInfo.mailAddress })
      if (sendRes.success) {
        Notify({ type: 'success', message: '操作成功' })
      } else {
        Notify({ type: 'danger', message: sendRes.message })
        return true
      }
    },
    async getTableData ({ commit, state }) {
      await commit('setLoading', true)
      const query = { ...state.query }
      const table = deepCopy(state.tableData)
      const res = await invoiceRequest.apply.getInvoicePage({
        ...query,
        startDate: moment(query.startDate).format('YYYY-MM-DD') + ' 00:00:00',
        endDate: moment(query.endDate).format('YYYY-MM-DD') + ' 23:59:59',
        invoiceType: query.invoiceType || '3,4,7,8'
      })
      try {
        if (res.success && res.result) {
          await commit('setTotal', res.result.total || 0)
          await commit('setTableData', table.concat(res.result.records || []))
        } else {
          Notify({ type: 'danger', message: res.message })
        }
      } catch (error) {
        console.error(error)
      } finally {
        await commit('setLoading', false)
      }
    }
  },
  mutations: {
    setQuery (state, { field, value }) {
      state.query = {
        ...state.query,
        [field]: value
      }
    },
    setInvoiceInfo (state, invoiceInfo) {
      state.invoiceInfo = invoiceInfo
    },
    setTableData (state, tableData) {
      state.tableData = tableData
    },
    initTableData (state) {
      state.tableData = []
    },
    setTotal (state, total) {
      state.total = total
    },
    setLoading (state, loading) {
      state.loading = loading
    }
  }
}
